function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path-159315004757816",
  d: "M2.666667593363553 6.2578857772525245 C2.666667593363553 6.2578857772525245 1.580694679786841 7.377974282130408 1.580694679786841 7.377974282130408 C1.580694679786841 7.377974282130408 11.583711078151591 17.257885777252525 11.583711078151591 17.257885777252525 C11.583711078151591 17.257885777252525 21.580694679786845 7.377974282130408 21.580694679786845 7.377974282130408 C21.580694679786845 7.377974282130408 20.50678890416394 6.2578857772525245 20.50678890416394 6.2578857772525245 C20.50678890416394 6.2578857772525245 11.583711078151591 15.078582363569858 11.583711078151591 15.078582363569858 C11.583711078151591 15.078582363569858 2.666667593363553 6.2578857772525245 2.666667593363553 6.2578857772525245 Z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgChevronDown = function SvgChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 -5 20 20",
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.580694679786841, -6.2578857772525245)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(0, 90, 131)"
    },
    d: "M2.666667593363553 6.2578857772525245 C2.666667593363553 6.2578857772525245 1.580694679786841 7.377974282130408 1.580694679786841 7.377974282130408 C1.580694679786841 7.377974282130408 11.583711078151591 17.257885777252525 11.583711078151591 17.257885777252525 C11.583711078151591 17.257885777252525 21.580694679786845 7.377974282130408 21.580694679786845 7.377974282130408 C21.580694679786845 7.377974282130408 20.50678890416394 6.2578857772525245 20.50678890416394 6.2578857772525245 C20.50678890416394 6.2578857772525245 11.583711078151591 15.078582363569858 11.583711078151591 15.078582363569858 C11.583711078151591 15.078582363569858 2.666667593363553 6.2578857772525245 2.666667593363553 6.2578857772525245 Z",
    vectorEffect: "non-scaling-stroke"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-down.33c4143a.svg";
export { ForwardRef as ReactComponent };